/**
 * This file is the entry point for the application.
 * It imports the CSS file and initializes the functions on DOMContentLoaded event.
 */
import '../css/app.css';

import templates from './templates';
/*
import { fadeElements } from './services/ui.service';
*/

document.addEventListener('DOMContentLoaded', function() {
	templates();
//	fadeElements();
});
